/**
   * 대상 웹 게임에 대해 사용자의 추가 약관 동의 필요 여부 및 계정 상태를 확인합니다.
   * 단, 추가 약관 동의 플로우는 웹 게임 초기화 시점(web-game-auth)에 진행합니다.
   */
export const checkAccountStatus = async (context) => {
  const {
    infaceAuth, accountStatusHandler, targetGid, webToken, logger,
  } = context

  const { success, error, data } = await infaceAuth.toyTermsService.getTermsWithWebToken({ gid: targetGid, webToken })

  if (!success) {
  /**
   * 계정 상태에 따라 다음과 같은 응답이 발생할 수 있으며
   * 전체 플로우를 중단하거나, 다시 처음부터 시작할 수 있습니다.
   *
   *  - GUID 휴면 복구: errorResponse = { status: STEP_STATUS.RESTART, payload: {} }
   *  - 게임 탈퇴 유예 복구: errorResponse = { status: STEP_STATUS.RESTART, payload: {} }
   *  - 그 외: errorResponse = { status: STEP_STATUS.STOP, payload: {} }
   */
    console.log('[SSOForWebGame] Account status check error', error)

    const handleErrorResponse = await accountStatusHandler.handleError(error, { webToken })
    if (handleErrorResponse) {
      return handleErrorResponse
    }
  }

  logger.addBreadcrumb({
    type: 'info',
    category: 'sso-for-web-game',
    message: '[signInForWeb] Additional terms and account status check completed',
    level: 'info',
  })

  const { guid, ticket } = data
  return {
    payload: {
      guid,
      ticket,
    },
  }
}
